import React from 'react'
import "./stylesheet/button.css"

const Button = ( props ) => {
  return (
    <a href={props.link} target="_blank">
    <button className='btn' id='btn'>
        <span className="subtitle">{props.subtext}</span>
        <span className="title">{props.title}</span>

    </button></a>
  )
}

export default Button